import * as React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import _compact from 'lodash/compact';
import { ReactComponent as AudioIcon } from '@lifesize/ux-assets/vectors/svgIcons/headset.svg';
import { ReactComponent as VideoIcon } from '@lifesize/ux-assets/vectors/svgIcons/video.svg';
import Tooltip from 'components/Tooltip/Tooltip';
import * as classes from './CallButtons.module.scss';

interface CloseButtonProps {
  bigButton: boolean;
  handleAudioCall: () => void;
  handleVideoCall: () => void;
  isCallable: boolean;
}

export const CallButtons = (props: CloseButtonProps) => {
  const { isCallable, handleVideoCall, handleAudioCall, bigButton } = props;
  const icons: JSX.Element[] = [];

  const buttonClasses = _compact([classes.cardButton, bigButton ? classes.bigButton : '']).join(' ');

  if (isCallable) {
    icons.push(
      <button className={buttonClasses} key="1" onClick={handleVideoCall} data-testid="call-video">
        <VideoIcon data-testid="videoIcon" />
        <Tooltip
          fixPosition={true}
          shift="left"
          label={<FormattedMessage id="contacts.tooltip.video" defaultMessage="Call with camera on" />}
        />
      </button>
    );
    icons.push(
      <button className={buttonClasses} key="2" onClick={handleAudioCall} data-testid="call-audio">
        <AudioIcon data-testid="audioIcon" />
        <Tooltip
          fixPosition={true}
          shift="left"
          label={<FormattedMessage id="contacts.tooltip.audio" defaultMessage="Call with camera off" />}
        />
      </button>
    );
  } else {
    icons.push(
      <span className={`${buttonClasses} ${classes.disabled}`} key="1">
        <VideoIcon data-testid="videoIcon" />
      </span>
    );
    icons.push(
      <span className={`${buttonClasses} ${classes.disabled}`} key="2">
        <AudioIcon data-testid="audioIcon" />
      </span>
    );
  }

  return (
    <div className={classes.buttonBarContainer}>
      <div className={classes.buttonBar}>{icons}</div>
    </div>
  );
};

export default injectIntl(CallButtons);
